import { DUTY_ANALYTICS_METRICS, type DutyAnalyticsLayout } from '@pams/shared';
import { SURFACES } from '@/lib/surfaces';
import { DUTY_ANALYTICS_COPY } from '../copy';

/**
 * [P7C §2] What each figure counts, one entry per metric (the record is exhaustive, so a tenth figure
 * cannot ship without a note), then which orders are counted and — on the commissionerate's page —
 * why a division can read differently here than on its own page.
 *
 * ⚠️ [amended P7C.1 §3] HIDDEN, NOT DELETED — `SURFACES.dutyAnalyticsFigureNotes`, read here at RENDER so one
 * stub reaches both layouts. Its words open from each card's and section's info button (`FigureInfo`), and
 * `DutyAnalytics.test.tsx` holds both branches and the proof that nothing it held is out of reach.
 */
export const FiguresNotes = ({ layout }: { layout: DutyAnalyticsLayout }) => {
  if (!SURFACES.dutyAnalyticsFigureNotes) return null;
  return (
    <section
      data-testid="duty-analytics-notes"
      aria-labelledby="duty-analytics-notes-title"
      className="flex flex-col gap-3 rounded-lg border border-border bg-card p-5"
    >
      <h2 id="duty-analytics-notes-title" className="text-base font-medium text-heading">
        {DUTY_ANALYTICS_COPY.notesTitle}
      </h2>
      <dl className="grid grid-cols-1 gap-x-6 gap-y-2 text-sm @min-[880px]:grid-cols-2">
        {DUTY_ANALYTICS_METRICS.map((metric) => (
          <div key={metric} className="flex flex-col gap-0.5">
            <dt className="font-medium">{DUTY_ANALYTICS_COPY.columns[metric]}</dt>
            <dd className="text-muted-foreground">{DUTY_ANALYTICS_COPY.notes[metric]}</dd>
          </div>
        ))}
      </dl>
      <p className="text-sm text-muted-foreground">{DUTY_ANALYTICS_COPY.ordersNote}</p>
      {layout === 'COMMISSIONERATE' && (
        <p className="text-sm text-muted-foreground">{DUTY_ANALYTICS_COPY.layoutNote}</p>
      )}
    </section>
  );
};
